<style lang="scss"></style>

<template>
  <div id="modal-remove-resina" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="resina">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de resina
                    <span
                      class="text-info"
                    >{{ resina.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoResinaService from '../../../services/TipoResinaService';

export default {
  name: 'modal-remove-resina',
  data() {
    return {
      enviando: false,
      resina: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-resina').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeResinaId = null;
    });

    if (this.$parent.removeResinaId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.resina = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeResinaId === 0) return;

        this.resina = await TipoResinaService.findById(
          this.$parent.removeResinaId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-resina').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoResinaService.remove(this.resina.id);

        this.$toast.success('Tipo de resina removida com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-resina').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
